import { Routes, RouterModule, RouterLink, RouterLinkActive, RouterOutlet } from '@angular/router';

import { LoginComponent } from './login/login.component';
import { HomeComponent } from './home/home.component';
import { PortComponent } from './port/port.component';

import { AddPmoComponent } from './home/add-pmo/add-pmo.component';
import { AddPortComponent } from './home/add-port/add-port.component';
import { AddProjectComponent } from './port/add-project/add-project.component';

import { AdminComponent } from './admin/admin.component';
import { UsersComponent } from './admin/users/users.component';
import { FacilityTypesComponent } from './admin/facility-types/facility-types.component';
import { ProjectTypesComponent } from './admin/project-types/project-types.component';

import { ProjectComponent } from './project/project.component';
import { EditProjectComponent } from './project/edit-project/edit-project.component';
import { PastComponent } from './projects/past/past.component';
import { CurrentComponent } from './projects/current/current.component';
import { FutureComponent } from './projects/future/future.component';

import { AuthGuard } from './_guards/auth.guard';

const appRoutes: Routes = [
    {
        path: '', component: HomeComponent, canActivate: [AuthGuard], children: [
            {
                path: 'add-pmo',
                component: AddPmoComponent
            },
            {
                path: ':pmoId/add-port',
                component: AddPortComponent
            }
        ]
    },

    // Admin routes
    {
        path: 'admin', component: AdminComponent, canActivate: [AuthGuard], children: [
            {
                path: '',
                redirectTo: 'users',
                pathMatch: 'full'
            },
            {
                path: 'users',
                component: UsersComponent
            },
            {
                path: 'facility-types',
                component: FacilityTypesComponent
            },
            {
                path: 'project-types',
                component: ProjectTypesComponent
            }
        ]
    },

    { path: ':portId/:slug/map/:year/:type/:facilityId/:facilitySlug/add-project/:x/:y', component: AddProjectComponent, canActivate: [AuthGuard] },
    { path: ':portId/:slug/map/:year/:type/:facilityId/:facilitySlug/add-project', component: AddProjectComponent, canActivate: [AuthGuard] },
    {
        path: ':portId/:slug/projects/past', component: PastComponent, canActivate: [AuthGuard], children: [
            {
                path: '',
                redirectTo: 'planning',
                pathMatch: 'full'
            },
            {
                path: 'planning',
                component: PastComponent
            },
            {
                path: 'navigation',
                component: PastComponent
            },
            {
                path: 'sounding',
                component: PastComponent
            }
        ]
    },
    {
        path: ':portId/:slug/projects/current', component: CurrentComponent, canActivate: [AuthGuard], children: [
            {
                path: '',
                redirectTo: 'planning',
                pathMatch: 'full'
            },
            {
                path: 'planning',
                component: FutureComponent
            },
            {
                path: 'navigation',
                component: FutureComponent
            },
            {
                path: 'sounding',
                component: FutureComponent
            }
        ]
    },
    {
        path: ':portId/:slug/projects/future', component: FutureComponent, canActivate: [AuthGuard], children: [
            {
                path: '',
                redirectTo: 'planning',
                pathMatch: 'full'
            },
            {
                path: 'planning',
                component: FutureComponent
            },
            {
                path: 'navigation',
                component: FutureComponent
            },
            {
                path: 'sounding',
                component: FutureComponent
            }
        ]
    },
    { path: ':portId/:slug/projects/:projectId/edit', component: EditProjectComponent, canActivate: [AuthGuard] },
    { path: ':portId/:slug/projects/:projectId', component: ProjectComponent, canActivate: [AuthGuard] },

    // These three routes are for viewing port
    { path: ':portId/:slug/map/:year/:type/:facilityId/:facilitySlug', component: PortComponent, canActivate: [AuthGuard] },
    { path: ':portId/:slug/map/:year/:type', component: PortComponent, canActivate: [AuthGuard] },
    { path: ':portId/:slug/map/:year', component: PortComponent, canActivate: [AuthGuard] },
    { path: ':portId/:slug/map', component: PortComponent, canActivate: [AuthGuard] },

    { path: 'account/login', component: LoginComponent },

    // otherwise redirect to Home
    { path: '**', redirectTo: '' }
];

export const routing = RouterModule.forRoot(appRoutes);



// WEBPACK FOOTER //
// ./Angular/app/app.routing.ts